/* eslint-disable no-underscore-dangle */
import React from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Alert,
} from '@mui/material'

/**
 * Read-only JSON viewer, shared by the Activities table (raw record) and the Logs table
 * (pre-delete snapshot).
 */
const ActivitySnapshotDialog = ({ open, onClose, title = 'Raw record', data = null, truncated = false }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle sx={{ fontWeight: 600 }}>{title}</DialogTitle>
    <DialogContent dividers>
      {truncated && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          The <code>data</code> field was too large to store in full and has been truncated.
        </Alert>
      )}
      <Box
        component="pre"
        sx={{
          m: 0,
          p: { xs: 1.5, sm: 2 },
          borderRadius: 1,
          bgcolor: (theme) => (theme.palette.mode === 'light' ? 'grey.100' : 'grey.900'),
          fontSize: { xs: '0.75rem', sm: '0.8125rem' },
          fontFamily: 'monospace',
          overflowX: 'auto',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}>
        {data ? JSON.stringify(data, null, 2) : 'No data'}
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} sx={{ textTransform: 'none' }}>
        Close
      </Button>
    </DialogActions>
  </Dialog>
)

ActivitySnapshotDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object,
  truncated: PropTypes.bool,
}

export default ActivitySnapshotDialog
